export default __webpack_public_path__ + "static/media/myInfo_business_button.3f23a8cf.svg";